import React from 'react'
import PropTypes from 'prop-types'
import styles from './UndoSlateButton.scss'
import { Button, Tooltip } from 'reactstrap'
import { FaRotateLeft, FaRepeat } from 'react-icons/lib/fa'

class UndoButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false,
      isUndo: !props.isRedo
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  onClickButton = () => {
    const { state, onChange } = this.props
    const { isUndo } = this.state
    const transform = state.transform()
    if (isUndo) {
      transform.undo()
    } else {
      transform.redo()
    }
    return onChange(transform.apply({save: false}))
  }

  render () {
    const { isUndo } = this.state

    return (
      <Button
        id={'UndoButton' + this.uid}
        onClick={this.onClickButton}
        color='secondary'
        className={styles.UndoButton}
      >
        {
          process.env.NODE_ENV !== 'test' &&
          <Tooltip className={styles.Tooltip} placement='top' isOpen={this.state.tooltipOpen} target={'UndoButton' + this.uid} toggle={this.toggle} autohide={false}>
            { isUndo ? 'Undo' : 'Redo' }
          </Tooltip>
        }
        {
          isUndo
          ? <FaRotateLeft />
          : <FaRepeat />
        }
      </Button>
    )
  }
}

UndoButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  isRedo: PropTypes.bool
}

export default UndoButton



// WEBPACK FOOTER //
// ./src/components/UndoSlateButton/UndoSlateButton.js